import React, { useEffect, useState } from 'react';

export enum LottieAnimation {
  AGILE_DEVELOPMEMT = "AGILE_DEVELOPMEMT",
  CONTINUOUS_FEEDBACK = "CONTINUOUS_FEEDBACK",
  AWARD = "AWARD",
  PHONE_APPS = "PHONE_APPS",
  SHOP = "SHOP",
  DIFUSION = "DIFUSION",
  PROCESS = "PROCESS",
  LOADING = "LOADING"
}

interface LottieProps {
  animation: LottieAnimation;
  className?: string;
}

export const Animation = (props: LottieProps) => {
  const { animation, className } = props;
  const [Lottie, setLottie] = useState<any>(null);
  const [LottieElement, setLottieElement] = useState<any>(null);

  useEffect(() => {
    if(!Lottie){
      import("react-lottie-player").then((LottieModule) => {
        setLottie(LottieModule.default);
      });
    }

    if(!LottieElement){
      import(`./animations/${animation.toLowerCase()}.json`).then((AnimationData) => {
        setLottieElement(AnimationData);
      });
    }
  }, [animation, Lottie, LottieElement]);

  if(!Lottie || !LottieElement){
    return (
      <div>
        Cargando lottie
      </div>
    )
  }

  return (
    <Lottie
      animationData={LottieElement}
      loop
      play
      style={{
        width : '100%',
        height: '100%'
      }}
      className={className}
    />
  );
};
